export default {
    greyDarker: "#222527",
    greyDark: "#35383B",
    grey: "#5D6368",
    greyLight: "#B2B6B9",
    greyLightest: "#D8DADC",
    greyAlmostWhite: "#EBECED",
    greyWhite: "#F9FAFA",
    greyNotWhite: "#F5F5F5"
}